import {Grey17, Grey6} from "../../theme/styles";

import {PlatformTable2} from "../PlatformTable2";
import {withAppContext} from "../../util/withAppContext";
import withNavigate from "../../util/useNavigate";
import withBreakpoint from "../../util/withBreakpoint";
import {IconButton, Menu, MenuItem, Typography, Tooltip} from "@mui/material";
import css_buttons from "../../components/Common/css/CCButton.module.scss";
import css_self from "../Navigation/css/NavBar.module.scss";
import React from "react";
import EventBus from "../../util/EventBus";
import {ControlPoint, DeleteForever, Edit, Info, MoreVert, Refresh} from "@mui/icons-material";
import {hasPrivilege} from "../../util/SessionContext";
import ProjectPlanPhaseMilestoneEmployeeFormApplet from "../../eoec/applet/impl/ProjectPlan/ProjectPlanPhaseMilestoneEmployeeFormApplet";

class ProjectPlanPhaseMilestoneEmployeeTable extends PlatformTable2 {

    componentDidMount() {
        super.componentDidMount();

        EventBus.components.addListener("project-plan-phase-milestone-employee-form-applet-cancel", this.onCancelHandler);
        EventBus.components.addListener("project-plan-phase-milestone-employee-form-applet-save", this.onCancelHandler);
    };

    componentWillUnmount() {
        super.componentWillUnmount();

        EventBus.components.removeListener("project-plan-phase-milestone-employee-form-applet-cancel", this.onCancelHandler);
        EventBus.components.removeListener("project-plan-phase-milestone-employee-form-applet-save", this.onCancelHandler);
    };

    getCellRenderer(name) {
        if (name === "Action Cell") {
            return this.renderActionCell;
        }

        return super.getCellRenderer(name);
    };

    handleMenuClick(identifier) {
        if (identifier === "Add Assignee") {
            this.setState({renderTarget: "Add Assignee"});
        }
        super.handleMenuClick(identifier);
    }

    onCancelHandler = () => {
        this.setState({renderTarget: null});
    };

    renderExtension() {
        if (this.state.renderTarget === "Add Assignee") {
            return <ProjectPlanPhaseMilestoneEmployeeFormApplet enterpriseComponent={this.applet.getEnterpriseComponent()} defaultAction="New"/>;
        }
        if (this.state.renderTarget === "Edit Assignee") {
            return <ProjectPlanPhaseMilestoneEmployeeFormApplet enterpriseComponent={this.applet.getEnterpriseComponent()} defaultAction="Edit"/>;
        }
        if (this.state.renderTarget === "Delete Assignee") {
            return <ProjectPlanPhaseMilestoneEmployeeFormApplet enterpriseComponent={this.applet.getEnterpriseComponent()} defaultAction="Delete"/>;
        }
    };

    getAddEmployeeTooltip() {
        if (this.applet.getEnterpriseComponent().getEnterpriseObject().getEnterpriseComponent("ProjectPlanPhaseMilestone").getAttributeValue("ProjectPlanPhaseStatus") === "DONE") {
            return "This feature is not available because the status of the phase is 'DONE'"
        }
        if (hasPrivilege("Add Milestone Assignee") === false) {
            return "This feature is disabled because you do not have the 'Add Milestone Assignee' privilege in any of your assigned roles."
        }
    }

    renderMenuContent() {
        let menuItems = [];

        menuItems.push(
            <MenuItem key={"menuItem1"} onClick={(e) => {
                if (hasPrivilege("Add Milestone Assignee") && this.applet.getEnterpriseComponent().getEnterpriseObject().getEnterpriseComponent("ProjectPlanPhaseMilestone").getAttributeValue("ProjectPlanPhaseStatus") !== "DONE" && this.applet.getEnterpriseComponent().getEnterpriseObject().getEnterpriseComponent("ProjectPlanPhaseMilestone").getAttributeValue("Status") !== "DONE") {
                    e.stopPropagation();
                    this.handleMenuClick("Add Assignee");
                    this.setState({showMenu: false});
                } else {
                    // do nothing
                }
            }}>
                <div style={{marginTop: "6px", marginRight: "5px"}}>
                    <ControlPoint sx={{color: "#1498D8", width: "25px", height: "25px"}}/>
                </div>
                Add Assignee
                {!hasPrivilege("Add Milestone Assignee") || this.applet.getEnterpriseComponent().getEnterpriseObject().getEnterpriseComponent("ProjectPlanPhaseMilestone").getAttributeValue("Status") === "DONE" || this.applet.getEnterpriseComponent().getEnterpriseObject().getEnterpriseComponent("ProjectPlanPhaseMilestone").getAttributeValue("ProjectPlanPhaseStatus") === "DONE" ? (
                    <div style={{marginLeft: "10px", marginTop: "6px"}}>
                        <Tooltip title={this.getAddEmployeeTooltip()}>
                            <Info sx={{color: "#F1C40F", width: "25px", height: "25px"}}/>
                        </Tooltip>
                    </div>
                ) : null}
            </MenuItem>
        );
        menuItems.push(
            <MenuItem key={"menuItem2"} onClick={(e) => {
                e.stopPropagation();
                this.handleMenuClick("Refresh");
                this.setState({showMenu: false});
            }}>
                <div style={{marginTop: "6px", marginRight: "5px"}}>
                    <Refresh sx={{color: "#1498D8", width: "25px", height: "25px"}}/>
                </div>
                Refresh
            </MenuItem>
        );

        return menuItems;
    };

    renderActionCell = (instance, params, columnId, _) => {
        if (params.row.id > this.state.buffer.length - 1) return;

        return (
            <div style={{width: "50px", backgroundColor: "#FFFFFF", marginLeft: "-10px"}}>
                <IconButton className={css_buttons.tableOptionButton} disableRipple sx={{"&:hover": {backgroundColor: "transparent"}}} onMouseDown={(event) => event.stopPropagation()} onClick={(event) => { event.stopPropagation();
                    this.applet.getEnterpriseComponent().selectRecord(params.row.id); this.setState({actionMenuAnchor: event.currentTarget, actionMenuRowId: params.row.id});
                }}>
                    <MoreVert sx={{fontSize: "1.35rem", position: "relative", top: "-1px"}} />
                </IconButton>
                <Menu
                    anchorEl={this.state.actionMenuAnchor}
                    anchorOrigin={{vertical: "center", horizontal: "right"}}
                    transformOrigin={{vertical: "top", horizontal: "left"}}
                    open={this.state.actionMenuRowId === params.row.id && !!this.state.actionMenuAnchor}
                    onClose={() => this.setState({actionMenuAnchor: null, actionMenuRowId: null})}
                    slotProps={{
                        paper: {elevation: 0, sx: {boxShadow: "none", borderRadius: 0, border: "1px solid #A8A9AF"}},
                        list: {...{"data-cc-component": "NavMenu"}, disablePadding: true, sx: {minWidth: "200px", "& .MuiMenuItem-root": {minHeight: "33px", height: "33px"}}},
                        transition: {onExited: () => this.setState({actionMenuAnchor: null, actionMenuRowId: null})},
                    }}
                >
                        <MenuItem divider key={"1"} className={css_self.Standard} onClick={() => {
                            if (hasPrivilege("Edit Milestone Assignee") && this.applet.getEnterpriseComponent().getAttributeValue("MilestoneStatus") !== "DONE" && (this.applet.getEnterpriseComponent().getAttributeValue("PhaseStatus") !== "DONE" || this.applet.getEnterpriseComponent().getAttributeValue("PhaseStatus") !== null)) {
                                this.applet.getEnterpriseComponent().selectRecord(params.row.id); this.setState({actionMenuAnchor: null, actionMenuRowId: null, renderTarget: "Edit Assignee"});
                            }
                        }}>
                            <Edit style={{color: Grey6}} />
                            <Typography style={{fontSize: "15px", fontWeight: "400", color: Grey17}}>Edit Assignee</Typography>
                            {!hasPrivilege("Edit Milestone Assignee") || this.state.buffer[params.row.id].get("MilestoneStatus") === "DONE" || this.applet.getEnterpriseComponent().getAttributeValue("PhaseStatus") === "DONE" ? (
                                <div style={{marginTop: "6px"}}>
                                    <Tooltip title={this.applet.getEnterpriseComponent().getAttributeValue("PhaseStatus") === "DONE" ? "This feature is disabled because the Phase is 'DONE'." : this.applet.getEnterpriseComponent().getAttributeValue("MilestoneStatus") === "DONE" ? "This feature is disabled because the milestone status is 'DONE'." : "This feature is disabled because you do not have the 'Edit Milestone Reference' privilege in any of your assigned roles."}>
                                        <Info sx={{color: "#F1C40F", width: "25px", height: "25px"}}/>
                                    </Tooltip>
                                </div>
                            ) : null}
                        </MenuItem>

                    <MenuItem divider key={"2"} className={css_self.Standard} onClick={() => {
                        if (hasPrivilege("Edit Milestone Assignee") && this.applet.getEnterpriseComponent().getAttributeValue("MilestoneStatus") !== "DONE" && this.applet.getEnterpriseComponent().getAttributeValue("PhaseStatus") !== "DONE") {
                            this.applet.getEnterpriseComponent().selectRecord(params.row.id); this.setState({actionMenuAnchor: null, actionMenuRowId: null, renderTarget: "Delete Assignee"});
                        }
                    }}>
                        <DeleteForever style={{color: Grey6}} />
                        <Typography style={{fontSize: "15px", fontWeight: "400", color: Grey17}}>Delete Assignee</Typography>
                        {!hasPrivilege("Edit Milestone Assignee") || this.applet.getEnterpriseComponent().getAttributeValue("MilestoneStatus") === "DONE" || this.applet.getEnterpriseComponent().getAttributeValue("PhaseStatus") === "DONE" ? (
                            <div style={{marginTop: "6px"}}>
                                <Tooltip title={this.applet.getEnterpriseComponent().getAttributeValue("PhaseStatus") === "DONE" ? "This feature is disabled because the Phase is 'DONE'." : this.applet.getEnterpriseComponent().getAttributeValue("MilestoneStatus") === "DONE" ? "This feature is disabled because the milestone status is 'DONE'." : "This feature is disabled because you do not have the 'Delete Milestone Reference' privilege in any of your assigned roles."}>
                                    <Info sx={{color: "#F1C40F", width: "25px", height: "25px"}}/>
                                </Tooltip>
                            </div>
                        ) : null}
                    </MenuItem>
                </Menu>
            </div>
        );
    };
}

export default withNavigate(withAppContext(withBreakpoint(ProjectPlanPhaseMilestoneEmployeeTable)));